module.exports = {
	"0": "0x8b1b00be6b60739f8602f6cdda67a79f746555c0",
	"1": "0xe04d0f4fde42df86941d2b1c54bd22185f4219b0",
	"2": "0x16ab2bfe41acd8bc97a6e6b5570a93f701fd47b8",
	"3": "0x9fa35a6057a0a5953d11a06908ad5123ccde06b4",
	"4": "0x367b4d28119e6cf7d85c42df9ea88153db45558f",
	"5": "0x89aeaa08a881394da1b960a424c4fd5ae5c2c61d",
	"6": "0xac3343c290e07ffd61b5e7c440541b6b274d9183",
	"7": "0x5a5c66accde55765ae10a4bad1f436b6f404ab1e",
	"8": "0x6a250e76b574b5b26b8953a5229b623f5e68eab3",
	"9": "0x433ea2726686c1a4b9fcb0d48c03f261d922b3fb",
	"10": "0xfc9d89003504452d19a8f2a4a2214ee6175c23cd",
	"11": "0xf87dac1125e015493a2142de83fe24c288083ceb",
	"12": "0x6f9547a12a4a6b77a1380c8938b672a244d95016",
	"cypherpunks": "0x794f3861768519a809d31cb305e00be568fb29bf"
};


//////////////////
// WEBPACK FOOTER
// ./gamedata/deploy.ropsten.json
// module id = 1059
// module chunks = 0